'use client'
import { useRef } from 'react';
import { motion } from 'framer-motion';
import s from './complex.module.scss';
import ProjectFeaturedComponent from '@/components/singles/projectFeatured';
import { Status, Region, Typology } from '@/types/singles/category';
import { Image } from '@/types/common/ImageData';
import JournalFeaturedComponent from '@/components/singles/journalFeatured';
import JournalFeaturedComplexComponent from '@/components/singles/journalFeaturedComplex';
import ProjectFeaturedComplexComponent from '@/components/singles/projectFeaturedComplex';
import usePinShorterColumn from '@/utils/usePinShorterColumn';

interface ComplexProps {
    data: any;
}

export default function Complex({ data }: ComplexProps) {
    const firstColumnRef = useRef<HTMLDivElement>(null);
    const secondColumnRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    
    usePinShorterColumn(firstColumnRef, secondColumnRef, { minWidthSecond: 1025 });

    return (
        <div className={s.complex} ref={containerRef}>
            <div ref={firstColumnRef} className={s.firstColumn}>
                {data.firstColumn && data.firstColumn.map((column: any, i: number) => (
                    <div key={`firstColumn-${column.option}-${i}`} className={`${s[`columns${column.columns}`]} ${data.firstColumn.length == i + 1 && s.columnsTotal}`}>
                        {column.option === 'journal' ? (
                            column.journals.map((journal: any, index: number) => (
                                <motion.div  
                                    key={`journal-${index}-${i}`}
                                    className={s.column}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: Math.min(index * 0.1, 0.5) }}
                                    viewport={{ once: true }}>
                                    <JournalFeaturedComponent data={journal} full={column.columns == '1'}/>
                                </motion.div>
                            ))
                        ) : (
                            column.projects && column.projects.map((project: any, index: number) => (
                                <motion.div  
                                    key={`project-${index}-${i}`}
                                    className={s.column}
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: Math.min(index * 0.1, 0.5) }}
                                    viewport={{ once: true }}>
                                    <ProjectFeaturedComponent data={project} full={column.columns == '1'}/>
                                </motion.div>
                            ))
                        )}
                    </div>
                ))}
            </div>
            <div ref={secondColumnRef} className={s.secondColumn}>
                {data.secondColumn && data.secondColumn.map((column: any, i: number) => (
                    <motion.div 
                        key={`second-column-${column._type}-${i}`}
                        className={s.column} 
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: Math.min(i * 0.1, 0.5) }}
                        viewport={{ once: true }}>
                        {column._type === 'chronicle' ? (
                            <JournalFeaturedComplexComponent data={column} />
                        ) : (
                            <ProjectFeaturedComplexComponent data={column} />
                        )}
                    </motion.div>
                ))}
            </div>
        </div>
    );
}